var map = {
	"./Approved.svg": 3755,
	"./AwaitingParts.svg": 3756,
	"./Closed.svg": 3757,
	"./Completed.svg": 3758,
	"./Excel.svg": 3759,
	"./Exportall_grey.svg": 3760,
	"./Exportall_grey_circle.svg": 3761,
	"./InProgress.svg": 3762,
	"./New.svg": 3763,
	"./View_Pic_Grey.svg": 3764,
	"./accident.svg": 3765,
	"./account.svg": 3766,
	"./addOrange.svg": 3767,
	"./addUser.svg": 3768,
	"./addVehicle.svg": 3769,
	"./address.svg": 3770,
	"./alert.svg": 3771,
	"./all_active.svg": 3772,
	"./all_active_es.svg": 3773,
	"./arrow-down.svg": 3774,
	"./arrow-up.svg": 3775,
	"./arrowRight.svg": 3776,
	"./awaiting_parts_grey.svg": 3777,
	"./awaiting_parts_orange.svg": 3778,
	"./back-btn.svg": 3779,
	"./back-button-grey.svg": 3780,
	"./backButton.svg": 3781,
	"./bills_of_landing_active.svg": 3782,
	"./bills_of_landing_active_es.svg": 3783,
	"./bobTail.svg": 3784,
	"./book-solid.svg": 3785,
	"./boxTruck.svg": 3786,
	"./calanderIcon.svg": 3787,
	"./cameraSelected.svg": 3788,
	"./camera_selected.svg": 3789,
	"./chat-icon.svg": 3790,
	"./circle-Exportall_grey.svg": 3791,
	"./circle-export.svg": 3792,
	"./circle-exportUser.svg": 3793,
	"./circle-import.svg": 3794,
	"./circle-importUser.svg": 3795,
	"./circle-viewall.svg": 3796,
	"./clearAll.svg": 3797,
	"./close-popup.svg": 3798,
	"./closeMap.svg": 3799,
	"./closed-Orange.svg": 3800,
	"./closed-grey.svg": 3801,
	"./clusterIcon.svg": 3802,
	"./communication_records_active.svg": 3803,
	"./communication_records_active_es.svg": 3804,
	"./company.svg": 3805,
	"./companyIcon.svg": 3806,
	"./complete-Orange.svg": 3807,
	"./complete-grey.svg": 3808,
	"./csa.svg": 3809,
	"./csaSnapshot.svg": 3810,
	"./dailyDocuments.svg": 3811,
	"./dashboard.svg": 3812,
	"./dashboardIcon.svg": 3813,
	"./date.svg": 3814,
	"./delete.svg": 3815,
	"./deleteCircle.svg": 3816,
	"./delivery_receipts_active.svg": 3817,
	"./delivery_receipts_active_es.svg": 3818,
	"./departments.svg": 3819,
	"./departmetEdit.svg": 3820,
	"./developer.svg": 3821,
	"./direction.svg": 3822,
	"./dispatch_records_active.svg": 3823,
	"./dispatch_records_active_es.svg": 3824,
	"./document.svg": 3825,
	"./documents.svg": 3826,
	"./dot.svg": 3827,
	"./dotAudit.svg": 3828,
	"./dotauditIcon.svg": 3829,
	"./downarrowIcon.svg": 3830,
	"./download.svg": 3831,
	"./downloadCenter.svg": 3832,
	"./downloadCenterMenu.svg": 3833,
	"./driver-behaviour.svg": 3834,
	"./driver.svg": 3835,
	"./dryVan.svg": 3836,
	"./dtc.svg": 3837,
	"./dualCam.svg": 3838,
	"./dump.svg": 3839,
	"./edit.svg": 3840,
	"./editLogIcon.svg": 3841,
	"./editSvg.svg": 3842,
	"./en.svg": 3843,
	"./es.svg": 3844,
	"./excelNew.svg": 3845,
	"./export-grey.svg": 3846,
	"./export.svg": 3847,
	"./exportUser.svg": 3848,
	"./feedback.svg": 3849,
	"./file-pdf-regular.svg": 3850,
	"./filter.svg": 3851,
	"./flatBed.svg": 3852,
	"./fleet.svg": 3853,
	"./fleetCompanies.svg": 3854,
	"./fleetdriverIcon.svg": 3855,
	"./fleetvehiclesIcon.svg": 3856,
	"./fletBed.svg": 3857,
	"./fuel.svg": 3858,
	"./full.svg": 3859,
	"./hamburger.svg": 3860,
	"./help-icon.svg": 3861,
	"./historyLogs.svg": 3862,
	"./icon-delete.svg": 3863,
	"./icon-export.svg": 3864,
	"./icon-menu-logs.svg": 3865,
	"./ifta.svg": 3866,
	"./import.svg": 3867,
	"./importUser.svg": 3868,
	"./in_progress_grey.svg": 3869,
	"./in_progress_orange.svg": 3870,
	"./infoTruck.svg": 3871,
	"./inspection-dvir.svg": 3872,
	"./inspection.svg": 3873,
	"./key.svg": 3874,
	"./leftArrow.svg": 3875,
	"./location.svg": 3876,
	"./locationMap.svg": 3877,
	"./log.svg": 3878,
	"./logEdit.svg": 3879,
	"./logHistory.svg": 3880,
	"./logoutIcon.svg": 3881,
	"./logs.svg": 3882,
	"./logsIcon.svg": 3883,
	"./mack.svg": 3884,
	"./mail.svg": 3885,
	"./main_camera.svg": 3886,
	"./mappinPopup.svg": 3887,
	"./menu_companies.svg": 3888,
	"./menu_dailyLog.svg": 3889,
	"./menu_reports.svg": 3890,
	"./menu_reseller.svg": 3891,
	"./menu_vehicle.svg": 3892,
	"./messageSender.svg": 3893,
	"./messaging.svg": 3894,
	"./new_login.svg": 3895,
	"./ninePin.svg": 3896,
	"./nonEdit.svg": 3897,
	"./notFull.svg": 3898,
	"./not_started_grey.svg": 3899,
	"./not_started_orange.svg": 3900,
	"./otherTrailer.svg": 3901,
	"./otherTruck.svg": 3902,
	"./other_documents_active.svg": 3903,
	"./other_documents_active_es.svg": 3904,
	"./overview.svg": 3905,
	"./page-first.svg": 3906,
	"./page-last.svg": 3907,
	"./page-next.svg": 3908,
	"./page-prev.svg": 3909,
	"./phone.svg": 3910,
	"./pickup.svg": 3911,
	"./pneumaticTrailer.svg": 3912,
	"./policy.svg": 3913,
	"./popupClose.svg": 3914,
	"./popupConfirm.svg": 3915,
	"./popupDelete.svg": 3916,
	"./privatePassenger.svg": 3917,
	"./qbdii.svg": 3918,
	"./receipts_active.svg": 3919,
	"./receipts_active_es.svg": 3920,
	"./reeferTrailer.svg": 3921,
	"./refreshCircle.svg": 3922,
	"./renewal.svg": 3923,
	"./repair.svg": 3924,
	"./reportIcon.svg": 3925,
	"./reports.svg": 3926,
	"./save-regular.svg": 3927,
	"./scoreCard.svg": 3928,
	"./searchGrey.svg": 3929,
	"./selectedConnection.svg": 3930,
	"./share.svg": 3931,
	"./sixPin.svg": 3932,
	"./sort.svg": 3933,
	"./speedometer.svg": 3934,
	"./spotlightGreen.svg": 3935,
	"./spotlightGrey.svg": 3936,
	"./spotlightRed.svg": 3937,
	"./straightTruck.svg": 3938,
	"./supportIcon.svg": 3939,
	"./switch.svg": 3940,
	"./tankerTrailer.svg": 3941,
	"./tick.svg": 3942,
	"./time.svg": 3943,
	"./timePicker.svg": 3944,
	"./toggle-off.svg": 3945,
	"./toggle-on.svg": 3946,
	"./tools.svg": 3947,
	"./tractorDayCab.svg": 3948,
	"./tractorSleeper.svg": 3949,
	"./undelete.svg": 3950,
	"./unsaved.svg": 3951,
	"./update.svg": 3952,
	"./upload.svg": 3953,
	"./usdot.svg": 3954,
	"./user.svg": 3955,
	"./userprofileIcon.svg": 3956,
	"./users.svg": 3957,
	"./vacuumTrailer.svg": 3958,
	"./vacuumTruck.svg": 3959,
	"./van.svg": 3960,
	"./vehicle-behaviour.svg": 3961,
	"./vehicle.svg": 3962,
	"./vehicleIcon.svg": 3963,
	"./viewArrow.svg": 3964,
	"./viewDocument.svg": 3965,
	"./viewReports.svg": 3966,
	"./viewStatus.svg": 3967,
	"./viewallMap.svg": 3968,
	"./violation.svg": 3969,
	"./volvo.svg": 3970,
	"./weigh_tickets_active.svg": 3971,
	"./weigh_tickets_active_es.svg": 3972,
	"./whitecheck_new.svg": 3973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3754;